// ===============================================================================
//
//  This file contains the class containing all the pathnames for surveys
//
// ===============================================================================

export class XmlExportComponentPaths {
    // ===============================================================================

    public static readonly BasePath: string = '/Data';

    // ===============================================================================

    public static readonly Ipc1752aPath: string = XmlExportComponentPaths.BasePath + '/Ipc1752a' +"/:inventoryId";

}